// The selected inbox is navigation state, not an implicit filter for the
// account-wide conversation list. Only an inbox in the route or selected in
// the conversation-list filter may restrict the request.
export const resolveConversationListInboxId = ({
  routeInboxId,
  filterInboxId,
} = {}) => routeInboxId || filterInboxId || undefined;
